module.exports = "/_next/static/images/main-visual-menu-none@2x-1681baf92643a6e5b912b450e83299a6.jpg";